import '../../styles/restScreens.css';
import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { supabaseClient } from '../../config/supabase';
import ClientOnboardingChecklist from './ClientOnboardingChecklist';

function ClientOnboardingWelcome() {
    const { accountId } = useParams();
    const [account, setAccount] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        let active = true;
        async function loadAccount() {
            const { data, error: accountError } = await supabaseClient
                .from('accounts')
                .select('id, org_id, account_name')
                .eq('id', accountId)
                .maybeSingle();
            if (!active) return;
            if (accountError) {
                setError('Your account could not be loaded. Please try again.');
            } else if (!data) {
                setError('This client account is unavailable.');
            } else {
                setAccount(data);
            }
            setLoading(false);
        }
        loadAccount();
        return () => { active = false; };
    }, [accountId]);

    return (
        <div data-m6-layout="clients" data-m6-component="ClientOnboardingWelcome" className="mx-auto max-w-3xl space-y-5">
            <div className="flex items-center justify-between gap-3">
                <p className="text-xs font-semibold uppercase tracking-wide text-[var(--ink-muted)]">
                    Your account setup
                </p>
                <Link
                    to="/clients"
                    className="ia-hover-pulse rounded-full border border-[var(--surface-border)] px-3 py-1.5 text-xs text-[var(--ink-muted)]"
                >
                    Back to clients
                </Link>
            </div>
            {loading && <p className="text-sm text-[var(--ink-muted)]">Loading client welcome…</p>}
            {error && <p className="text-sm text-[var(--ui-alert)]" role="alert">{error}</p>}
            {!loading && !error && account && (
                <div className="rounded-xl border border-[var(--surface-border)] bg-[var(--surface-raised)] p-5">
                    <ClientOnboardingChecklist account={account} readOnly welcome />
                </div>
            )}
        </div>
    );
}

export default ClientOnboardingWelcome;
